import * as React from "react";
import "./buttonSecondary.scss";
import classNames = require("classnames");

interface IProps {
	/**
	 * Button label text.
	 */
	label: string;
	/**
	 * On click event handler.
	 * @param {React.MouseEvent<HTMLButtonElement>} evt
	 */
	onClick: (evt: React.MouseEvent<HTMLButtonElement>) => void;
	/**
	 * Indicates if button should be disabled.
	 */
	disabled?: boolean;
	/**
	 * Indicates if button have to fit his parent.
	 */
	fit?: boolean;
	/**
	 * Indicates if button have selected state.
	 */
	selected?: boolean;
}

export default class ButtonSecondary extends React.Component<IProps, {}> {

	constructor(props: IProps) {
		super(props);
		this.onClick = this.onClick.bind(this);
	}

	render() {

		const classFromProps = classNames({
			"a-button-secondary": true,
			"is-fit": this.props.fit,
			"is-selected": this.props.selected
		});

		return (
			<button className={classFromProps}
					disabled={this.props.disabled}
					onClick={this.onClick}>
				{this.props.label}
			</button>
		);
	}

	onClick(event: React.MouseEvent<HTMLButtonElement>) {
		if (this.props.onClick && !this.props.disabled) {
			event.stopPropagation();
			this.props.onClick(event);
		}
	}
}
